const currencyRegionMap: { [key: string]: string } = {
  USD: 'na',
  CAD: 'na',
  MXN: 'na',
  EUR: 'eu',
  CZK: 'eu',
  DKK: 'eu',
  HUF: 'eu',
  NOK: 'eu',
  PLN: 'eu',
  RON: 'eu',
  SEK: 'eu',
  CHF: 'eu',
  GBP: 'eu',
  AUD: 'oc',
  NZD: 'oc',
  JPY: 'oc',
}

export const getRegionFromCurrency = (currency: string): string => {
  return currencyRegionMap[currency] || 'eu'
}
